<template>
  <div>
    <div class="header-container">
      <div class="header__wrappper">
        <div class="icon-img">
          <img :src="PackagingIcon" />
        </div>
        <div class="packaging-title__info">
          <div class="packing_scheme_name">
            {{ formData.evgPlanOrderName || '新增计划' }}
          </div>
          <div class="d-flex">
            <div>
              <span style="font-size: 14px; color: #606266">
                NO: {{ formData.evgPlanOrderNo || '计划编号自动生成' }}
              </span>
              <el-divider direction="vertical"></el-divider>
              <el-tag
                size="mini"
                :type="
                  formData.evgPlanOrderStatus === 'Y'
                    ? 'success'
                    : formData.evgPlanOrderStatus === 'D'
                    ? 'danger'
                    : 'primary'
                "
              >
                {{ formData.v_evgPlanOrderStatus || 'New' }}
              </el-tag>
              <el-divider direction="vertical"></el-divider>
              <span style="font-size: 14px; color: #606266">
                Modify: {{ formData.modifyByName || '--' }} at
                {{ formData.modifyDate || '--' }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box-container">
      <SearchTabs v-model="activeName" :code="newCode" />
      <div v-if="activeName == 'Plan'">
        <StockingPlan
          ref="stockingPlanRef"
          :disabled="disabled"
          :evgPlanOrderCode="newCode"
          @reload="getData"
        ></StockingPlan>
      </div>
      <div v-if="activeName == 'SkuInfo'">
        <PlanSkuInfo :evgPlanOrderCode="newCode"></PlanSkuInfo>
      </div>
      <div v-if="activeName == 'Estimate'">
        <Estimate :evgPlanOrderCode="newCode" :disabled="disabled"></Estimate>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import SearchTabs from '../search-tabs'
import StockingPlan from '../stocking-plan'
import PlanSkuInfo from '../plan-sku-info'
import Estimate from '../estimate'
const PackagingIcon = require('./packaging.svg')
export default {
  props: {
    evgPlanOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  components: { SearchTabs, StockingPlan, PlanSkuInfo, Estimate },
  data() {
    return {
      PackagingIcon,
      activeName: 'Plan',
      code: '',
      formData: {},
    }
  },
  computed: {
    newCode() {
      return this.evgPlanOrderCode || this.code
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.newCode) return

      this.$api
        .ecomEvgPlanOrderDetailApi({
          evgPlanOrderCode: this.newCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    reload(code) {
      this.code = code
      this.getData()
    },
  },
}
</script>
<style lang="scss" scoped>
.header-container {
  border-radius: 5px;
  height: 84px;
  width: 100%;
  padding: 15px;
  background-color: #ffffff;
  margin-bottom: 10px;
  .header__wrappper {
    display: flex;
    .icon-img {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background-color: #f4f9ff;
      margin-right: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      > img {
        width: 30px;
        height: 30px;
      }
    }
    .packaging-title__info {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .packing_scheme_name {
        color: #101010;
        font-size: 16px;
        font-weight: 600;
      }
    }
  }
}
.box-container {
  border-radius: 5px;
  background-color: #ffffff;
  padding: 15px;
}
</style>
